import React, { useMemo } from 'react';
import './UrpassSelect.css';
import { IonButton, IonIcon } from '@ionic/react';
import { useTranslation } from 'react-i18next';

type UrpassSelectProps = {
  title: string;
  subTitle?: string;
  description?: string;
  status?: string;
  icon?: string;
  midInfo?: string;
  midAction?: () => void;
  midActionLabel?: string | null;
  fullAction?: () => void;
  bottomAction?: () => void;
  bottomActionLabel?: string | null;
};

export default function UrpassSelect({
  icon,
  title,
  subTitle,
  description,
  bottomAction,
  bottomActionLabel,
  midAction,
  midInfo,
  midActionLabel,
  status,
  fullAction,
}: UrpassSelectProps) {
  const [t] = useTranslation('global');

  const fullClick = () => {
    if (fullAction) {
      fullAction();
    }
  };

  return (
    <>
      <div
        onClick={fullClick}
        className={'urpass-select ' + (fullAction ? 'urpass-select-click' : '')}
      >
        <div className="urpass-select-top">
          <IonIcon
            icon={'assets/urpass/' + icon + '.svg'}
            className="urpass-select-icon"
          />
          <div>
            <strong>{title}</strong>
            {subTitle && <span>{subTitle}</span>}
            {(midAction || midInfo) && (
              <div className="urpass-select-midaction">
                <span>{midInfo}</span>
                {midAction && (
                  <button onClick={() => midAction()}>{midActionLabel}</button>
                )}
              </div>
            )}
            {status && (
              <div
                className={
                  'urpass-select-status urpass-select-status-' +
                  status.toLowerCase()
                }
              >
                <b>{t('urpass.status')}</b>
                <span>&#9679; {t('urpass.status' + status.toLowerCase())}</span>
              </div>
            )}
          </div>
        </div>
        {description && (
          <>
            <hr />
            <small className="instructions">{description}</small>
          </>
        )}
        {bottomAction && (
          <div className="urpass-select-bottomaction">
            <IonButton onClick={() => bottomAction()}>
              {bottomActionLabel}
            </IonButton>
          </div>
        )}
      </div>
    </>
  );
}
